import { ApiService } from "../api.service";
import { StorageFilters } from "@/models/entities/storage/storageFilters.interface";
import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import { storageCertificate } from "@/models/entities/storage/storageInput/storageCertificate.interface";

const CONTROLLER = "products";

class ProductService extends ApiService {
  getProducts(filters: StorageFilters, page: number, numberRecord: number) {
    if (page > 0) page = page - 1;
    const element = {
      requestType:
        filters.requestType != null ? filters.requestType.toString() : "0",
      includeGiancezaZero:
        filters.includeGiancezaZero != null
          ? filters.includeGiancezaZero
          : false,
      onlyMoreThanFour:
        filters.onlyMoreThanFour != null ? filters.onlyMoreThanFour : false,
      codice: filters.codice != null ? filters.codice : "",
      keywords: filters.keywords != null ? filters.keywords : "",
      keywords2: filters.keywords2 != null ? filters.keywords2 : "",
      categoria: filters.categoria != null ? filters.categoria : "",
      catalogueSourceID:
        filters.catalogueSourceID != null ? filters.catalogueSourceID : "-1",
      brand: filters.brand,
      model: filters.model,
      cartype: filters.cartype,
      fromYear: filters.fromYear,
      type: filters.type,
      canale: filters.canale != null ? filters.canale : "-1",
      diametro: filters.diametro != null ? filters.diametro : "-1",
      fori: filters.fori != null ? filters.fori : "-1",
      pcd: filters.pcd != null ? filters.pcd : "-1",
      et_From: filters.et_From != null ? filters.et_From : "0",
      et_To: filters.et_To ? filters.et_To : "999999",
      foroCentrale_From:
        filters.foroCentrale_From != null ? filters.foroCentrale_From : "-1",
      foroCentrale_To:
        filters.foroCentrale_To != null ? filters.foroCentrale_To : "-1",
      tireDimension: filters.tireDimension,
      height: filters.height,
      category: filters.category,
      page: page != null ? page.toString() : "0",
      numberRecord: numberRecord != null ? numberRecord.toString() : "12",
      sortExpression: "ASC",
      OrderID: "-1",
      modelloRuota: filters.modelloRuota,
      finitura: filters.finitura,
    };
    return this.post<any, { length: number; data: StorageElements[] }>(
      `${CONTROLLER}/getall`,
      element
    );
  }

  getChains(filters: StorageFilters, page: number, numberRecord: number) {
    if (page > 0) page = page - 1;
    const element = {
      requestType:
        filters.requestType != null ? filters.requestType.toString() : "0",
      includeGiancezaZero:
        filters.includeGiancezaZero != null
          ? filters.includeGiancezaZero
          : false,
      onlyMoreThanFour:
        filters.onlyMoreThanFour != null ? filters.onlyMoreThanFour : false,
      codice: filters.codice != null ? filters.codice : "",
      keywords: filters.keywords != null ? filters.keywords : "",
      keywords2: filters.keywords2 != null ? filters.keywords2 : "",
      categoria: filters.categoria != null ? filters.categoria : "",
      catalogueSourceID:
        filters.catalogueSourceID != null ? filters.catalogueSourceID : "-1",
      brand: filters.brand,
      model: filters.model,
      cartype: filters.cartype,
      fromYear: filters.fromYear,
      type: filters.type,
      canale: filters.canale != null ? filters.canale : "-1",
      diametro: filters.diametro != null ? filters.diametro : "-1",
      fori: filters.fori != null ? filters.fori : "-1",
      pcd: filters.pcd != null ? filters.pcd : "-1",
      et_From: filters.et_From != null ? filters.et_From : "0",
      et_To: filters.et_To ? filters.et_To : "999999",
      foroCentrale_From:
        filters.foroCentrale_From != null ? filters.foroCentrale_From : "-1",
      foroCentrale_To:
        filters.foroCentrale_To != null ? filters.foroCentrale_To : "-1",
      tireDimension: filters.tireDimension,
      height: filters.height,
      category: filters.category,
      page: page != null ? page.toString() : "0",
      numberRecord: numberRecord != null ? numberRecord.toString() : "12",
      sortExpression: "ASC",
      OrderID: "-1",
      modelloRuota: filters.modelloRuota,
      finitura: filters.finitura,
    };
    return this.post<any, { length: number; data: StorageElements[] }>(
      `${CONTROLLER}/getallChain`,
      element
    );
  }

  getCertificate(
    code: string,
    certificate: string,
    catalogueSourceID: string | number
  ) {
    const parameters =
      "?productCode=" +
      code +
      "&certificate=" +
      certificate +
      "&catalogueSourceID=" +
      catalogueSourceID;

    return this.getAll<storageCertificate>(
      `${CONTROLLER}/getcertification${parameters}`
    );
  }
  getCertificateNAD(
    code: string,
    certificate: string,
    catalogueSourceID: string | number
  ) {
    const parameters =
      "?productCode=" +
      code +
      "&certificate=" +
      certificate +
      "&catalogueSourceID=" +
      catalogueSourceID;

    return this.getAll<string>(
      `${CONTROLLER}/getcertificationnad${parameters}`
    );
  }
}

export const productService = new ProductService();
